document.addEventListener('DOMContentLoaded', function(){
    // Add class to body if there are no banner section
    if (!document.querySelector('.index_banner_sec') && !document.querySelector('.common_banner_sec')) {
        document.body.classList.add('no_banner');
    }
    // Add class to body if there are no banner section

    // Scroll down to next section
    const scroll_button = document.getElementById('scrollBtn');
    if (scroll_button){
        scroll_button.addEventListener('click', () => {
            const sections = document.querySelectorAll('.shopify-section');
            const scrollPos = window.scrollY;
            for (let section of sections) {
                if (section.offsetTop > scrollPos) {
                section.scrollIntoView({ behavior: 'smooth' });
                break;
                }
            }
        });
    }
    // Scroll down to next section

    // Index Banner slide
    const index_splide = document.querySelector('.index_banner_sec .splide');
    if(index_splide){
        new Splide(index_splide, {
            type: 'loop',
            rewind: false,
            speed: 1000,
            perPage: 1,
            gap: '10px',
            arrows: false,
            pagination: true,
            autoplay: true,
            interval: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount();
    }
    // Index Banner slide

    // Index marque slider
    // const marque_slide = document.querySelector('#marque_slide');
    // if(marque_slide){
    //     new Splide('#marque_slide',{
    //         type   : 'loop',
    //         drag   : 'free',
    //         focus  : 'center',
    //         perPage: 1,
    //         gap: '20px',
    //         arrows: false,
    //         pagination: false,
    //         pauseOnHover: false,
    //         autoScroll: {
    //             speed: 1,
    //             pauseOnHover: false,
    //             pauseOnFocus: false,
    //         },
    //     }).mount(window.splide.Extensions);
    // }
    // Index marque slider

    // Index Supply slider
    const supply_slide = document.querySelector('.supply_slider');
    if (supply_slide) {
        const splide = new Splide('.supply_slider', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 3,
            gap: '30px',
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            breakpoints: {
                1024: {
                    perPage: 3,
                    gap: '20px',
                },
                989: {
                    perPage: 2,
                    gap: '20px',
                },
                480: {
                    perPage: 1,
                    gap: '10px',
                },
            }
        });

        const progressWrap = document.querySelector('.slider_progress');
        const progressBar = document.querySelector('.slider_progress_bar');
        const arrowsWrap = document.querySelector('.slider_arrows');

        function updateControlsVisibility() {
            const slideCount = splide.length;
            const perPage = splide.options.perPage;

            const shouldShow = slideCount > perPage;

            if (shouldShow) {
                progressWrap.style.display = '';
                arrowsWrap.style.display = '';
            } else {
                progressWrap.style.display = 'none';
                arrowsWrap.style.display = 'none';
            }
        }

        // Progress bar update
        splide.on('mounted move resized', () => {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            progressBar.style.width = `${rate * 100}%`;

            updateControlsVisibility();
        });

        // Custom arrows
        document.querySelector('.custom-prev').addEventListener('click', () => splide.go('<'));
        document.querySelector('.custom-next').addEventListener('click', () => splide.go('>'));

        splide.mount();
    }
    // Index marqSupplyue slider

    // FAQ accordion
    const faq_item = document.querySelectorAll(".faq_item");
  
    if (faq_item.length > 0){
        const first_item = faq_item[0];
        const first_faq_qus = first_item.querySelector(".faq_qus");
        const first_faq_ans = first_item.querySelector(".faq_ans");

        if (first_faq_qus && first_faq_ans){
            first_item.classList.add("open");
            first_faq_qus.classList.add("active");
            first_faq_ans.style.height = first_faq_ans.scrollHeight + "px";
        }
    }

    faq_item.forEach((item) => {
        const faq_qus = item.querySelector(".faq_qus");
        const faq_ans = item.querySelector(".faq_ans");

        if (faq_qus && faq_ans){
            faq_qus.addEventListener("click", function(){
                const isOpen = item.classList.contains("open");

                faq_item.forEach( i =>{
                    const qus = i.querySelector(".faq_qus");
                    const ans = i.querySelector(".faq_ans");

                    if (qus && ans){
                        i.classList.remove("open");
                        qus.classList.remove("active");
                        ans.style.height = 0;
                    }
                });

                if(!isOpen){
                    item.classList.add("open");
                    faq_qus.classList.add("active");
                    faq_ans.style.height = faq_ans.scrollHeight + "px";
                }
            });
        }
    });
    // FAQ accordion
});